import { useQuery } from '@apollo/client';
import { GET_MEMBER_APPLICANT_INFO } from '@frontend/app/queries';
import {
  GetMemberApplicantInfo,
  GetMemberApplicantInfoVariables
} from '@frontend/app/queries/types/GetMemberApplicantInfo';

interface UseMemberApplicantInfoProps {
  memberId: number | null;
  programId: number | null;
  skip?: boolean;
}

export const useMemberApplicantInfo = ({
  memberId,
  programId,
  skip = false
}: UseMemberApplicantInfoProps) => {
  const { data, loading, error, refetch } = useQuery<
    GetMemberApplicantInfo,
    GetMemberApplicantInfoVariables
  >(GET_MEMBER_APPLICANT_INFO, {
    variables: {
      memberId,
      programId,
    },
    skip: skip || !memberId || !programId,
    fetchPolicy: 'cache-and-network',
    errorPolicy: 'all',
  });

  return {
    memberApplicantInfo: data?.memberApplicantInfo,
    isLoading: loading,
    error,
    refetch,
  };
};
